module.exports = __webpack_public_path__ + "img/down-local-btn.c5d33728.png";